import reduceReducers from "reduce-reducers";

import {
  BUSINESS_MERGE_EVENTS,
  MERGE_BUSINESSES,
  UNMERGE_BUSINESSES,
} from "constants/actionTypes";

import { apiModelOfflineFetchReducer, reduceById } from "lib/reducers";
import { deserializeBusinessMergeEvents } from "lib/serializers/businessMergeEvents";

const fetch = apiModelOfflineFetchReducer(BUSINESS_MERGE_EVENTS, {
  deserializer: deserializeBusinessMergeEvents,
  clearOnRequest: true,
});

function mergeBusinessesSuccess(state, action) {
  switch (action.type) {
    case UNMERGE_BUSINESSES.CREATE.SUCCESS:
    case MERGE_BUSINESSES.CREATE.SUCCESS: {
      return {
        ...state,
        byId: {
          ...state.byId,
          ...reduceById([deserializeBusinessMergeEvents(action.payload)]),
        },
      };
    }
    default:
      return state;
  }
}

const businessMergeEventsReducer = reduceReducers(
  fetch,
  mergeBusinessesSuccess,
);

export default businessMergeEventsReducer;
